import AppEditorMixin from "@/protected/mixins/AppEditorMixin";
import AttachmentsForm, {
  onAttachmentEvent,
  onAttachmentsTabSelected
} from "@/protected/components/AttachmentsForm";
import MessagesForm, {
  onMessage,
  onMessagesTabSelected
} from "@/protected/components/MessagesForm";
import InfoForm from "./InfoForm";
import HelpForm from "./HelpForm";
import CurrentStatusForm from "./CurrentStatusForm";
import LogEntriesForm from "./LogEntriesForm";

const attachmentsContextList = self => [
  // =====================================================================
  // Allegati pratica
  // =====================================================================
  {
    label: "Allegati pratica - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: self.fileContextServerPath,
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    getId: value => value.id,
    getPermissions: value =>
      value.permissions.attachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "relativi solamente a " +
      '<strong class="text-dark">questa pratica</strong>.'
  },
  {
    label: "Allegati pratica - Visibilità: Gestori/Clienti",
    serverPath: self.fileContextServerPath,
    subcontext: "BROKER_CUSTOMER",
    getId: value => value.id,
    getPermissions: value => value.permissions.attachments.BROKER_CUSTOMER,
    message:
      "I file caricati in questa sezione sono visibili solamente " +
      'da <strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong>, ma ' +
      'non dai <strong class="text-danger">fornitori</strong> ' +
      "e sono relativi solamente a " +
      '<strong class="text-dark">questa pratica</strong>.'
  },
  // =====================================================================
  // Allegati richiesta
  // =====================================================================
  {
    label: "Allegati richiesta - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: self.requestContextServerPath,
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    //externalContext: self.externalContext,
    getId: value => value.request.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.requestAttachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">questa ed ogni altra pratica</strong> ' +
      "collegate alla " +
      '<strong class="text-primary">richiesta</strong>.'
  },
  {
    label: "Allegati richiesta - Visibilità: Gestori/Clienti",
    serverPath: self.requestContextServerPath,
    subcontext: "BROKER_CUSTOMER",
    //externalContext: self.externalContext,
    getId: value => value.request.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.requestAttachments.BROKER_CUSTOMER,
    message:
      "I file caricati in questa sezione sono visibili solamente " +
      'da <strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong>, ma ' +
      'non dai <strong class="text-danger">fornitori</strong> ' +
      "e sono richiamabili da " +
      '<strong class="text-dark">questa ed ogni altra pratica</strong> ' +
      "collegate alla " +
      '<strong class="text-primary">richiesta</strong>.'
  },
  // =====================================================================
  // Allegati cliente
  // =====================================================================
  {
    label: "Allegati cliente - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: "customers",
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    //externalContext: self.externalContext,
    getId: value => value.request.customer.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.customerAttachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questo " +
      '<strong class="text-primary">cliente</strong>.'
  },
  {
    label: "Allegati cliente - Visibilità: Gestori/Clienti",
    serverPath: "customers",
    subcontext: "BROKER_CUSTOMER",
    //externalContext: self.externalContext,
    getId: value => value.request.customer.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.customerAttachments.BROKER_CUSTOMER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong> ma non dai ' +
      '<strong class="text-danger">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questo " +
      '<strong class="text-primary">cliente</strong>.'
  },
  // =====================================================================
  // Allegati rete
  // =====================================================================
  {
    label: "Allegati agenzia - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: "networks",
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    //externalContext: self.externalContext,
    getId: value => value.request.network.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.networkAttachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questa " +
      '<strong class="text-primary">agenzia</strong>.'
  },
  {
    label: "Allegati agenzia - Visibilità: Gestori/Clienti",
    serverPath: "networks",
    subcontext: "BROKER_CUSTOMER",
    //externalContext: self.externalContext,
    getId: value => value.request.network.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.networkAttachments.BROKER_CUSTOMER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong> ma non dai ' +
      '<strong class="text-danger">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questa " +
      '<strong class="text-primary">agenzia</strong>.'
  },
  {
    label: "Allegati agenzia - Visibilità: Gestori/Fornitori",
    serverPath: "networks",
    subcontext: "BROKER_PROVIDER",
    //externalContext: self.externalContext,
    getId: value => value.request.network.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.networkAttachments.BROKER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">fornitori</strong> ma non dai ' +
      '<strong class="text-danger">clienti</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ed ' +
      '<strong class="text-dark">ogni richiesta</strong> ' +
      "collegate a questa " +
      '<strong class="text-primary">agenzia</strong>.'
  },
  // =====================================================================
  // Allegati fornitore
  // =====================================================================
  {
    label: "Allegati fornitore - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: "providers",
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    //externalContext: self.externalContext,
    getId: value => value.product.provider.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.providerAttachments.BROKER_CUSTOMER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questo " +
      '<strong class="text-primary">fornitore</strong>.'
  },
  {
    label: "Allegati fornitore - Visibilità: Gestori/Fornitori",
    serverPath: "providers",
    subcontext: "BROKER_PROVIDER",
    //externalContext: self.externalContext,
    getId: value => value.product.provider.id,
    //getExternalContextId: (value) => value.id,
    getPermissions: value =>
      value.permissions.providerAttachments.BROKER_PROVIDER,
    message:
      "I file caricati in questa sezione sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">fornitori</strong> ma non dai ' +
      '<strong class="text-success">clienti</strong> e sono ' +
      "richiamabili da " +
      '<strong class="text-dark">ogni pratica</strong> ' +
      "collegata a questo " +
      '<strong class="text-primary">fornitore</strong>.'
  }
];

const messagesContextList = self => [
  {
    label: "Messaggi pratica - Visibilità: Gestori/Clienti",
    serverPath: self.fileContextServerPath,
    subcontext: "BROKER_CUSTOMER",
    getId: value => value.id,
    getPermissions: value => value.permissions.messages.BROKER_CUSTOMER,
    message:
      "I messaggi scambiati in questa chat sono visibili solamente " +
      'da <strong class="text-success">gestori</strong> e ' +
      '<strong class="text-success">clienti</strong>, ma ' +
      'non dai <strong class="text-danger">fornitori</strong> ' +
      "e sono relativi solamente a " +
      '<strong class="text-dark">questa pratica</strong>.'
  },
  {
    label: "Messaggi pratica - Visibilità: Gestori/Clienti/Fornitori",
    serverPath: self.fileContextServerPath,
    subcontext: "BROKER_CUSTOMER_PROVIDER",
    getId: value => value.id,
    getPermissions: value =>
      value.permissions.messages.BROKER_CUSTOMER_PROVIDER,
    message:
      "I messaggi scambiati in questa chat sono visibili da " +
      '<strong class="text-success">gestori</strong>, ' +
      '<strong class="text-success">clienti</strong> e ' +
      '<strong class="text-success">fornitori</strong> e sono ' +
      "relativi solamente a " +
      '<strong class="text-dark">questa pratica</strong>.'
  }
];

export default {
  mixins: [AppEditorMixin],

  data() {
    return {
      unsatisfiedTagAlternatives: null
    };
  },

  computed: {
    tabs() {
      return [
        {
          component: HelpForm,
          title: () => this.$t("file.tabs.help"),
          icon: "question"
        },
        {
          component: CurrentStatusForm,
          title: () => this.$t("file.tabs.whereYouAre"),
          icon: "map-marker"
        },
        {
          component: this.FileForm,
          title: () => this.$t("file.tabs.main"),
          icon: "file"
        },
        {
          component: InfoForm,
          title: () => this.$t("file.tabs.info"),
          icon: "info"
        },
        {
          id: "attachments",
          component: AttachmentsForm,
          title: () => this.$t("file.tabs.attachments"),
          icon: "paperclip",
          show: !this.isNew,
          props: () => ({
            contextList: attachmentsContextList(this),
            unsatisfiedTagAlternatives: this.unsatisfiedTagAlternatives
          }),
          events: {
            "attachment-event": async evt => {
              const fn = onAttachmentEvent.bind(this);
              fn(evt);
              await this.getUnsatisfiedTagAlternatives();
            }
          },
          tabSelected: onAttachmentsTabSelected.bind(this)
        },
        {
          id: "messages",
          component: MessagesForm,
          show: !this.isNew,
          title: () => this.$t("file.tabs.messages"),
          icon: "comments",
          props: {
            contextList: messagesContextList(this)
          },
          events: {
            message: onMessage.bind(this)
          },
          tabSelected: onMessagesTabSelected.bind(this)
        },
        {
          component: LogEntriesForm,
          title: () => this.$t("file.tabs.logEntries"),
          icon: "clock"
        }
      ];
    }
  },

  async mounted() {
    await this.getUnsatisfiedTagAlternatives();
  },

  methods: {
    async getUnsatisfiedTagAlternatives() {
      const { data } = await this.getService().getUnsatisfiedTagAlternatives(
        this.value
      );
      this.unsatisfiedTagAlternatives = data;
      console.log(
        "unsatisfiedTagAlternatives",
        this.unsatisfiedTagAlternatives
      );
    }
  }
};
